import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { MedicineService } from "src/core/services/medicine.service";
import { DosageType, DosageUnit, Medicine, MedicineDosagePackageType, MedicineDosageType, PackageType } from "src/interfaces/medicine";
import { Order } from "src/interfaces/order";

@Injectable({
    providedIn: 'root'
})
export class MedicineResolver implements Resolve<any> {

    constructor(
        private _medicineService: MedicineService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{
        medicine: Medicine | null;
        medicineDosageTypes: MedicineDosageType[];
        dosageUnits: DosageUnit[],
        dosageTypes: DosageType[],
        packageTypes: PackageType[],
    }> {

        let medicine: Medicine | null = null;
        let medicineDosageTypes: MedicineDosageType[] = [];

        const dosageUnits: DosageUnit[] = await this._medicineService.getDosageUnits(1, 10, '');
        const dosageTypes: DosageType[] = await this._medicineService.getDosageTypes(1, 10, '');
        const packageTypes: PackageType[] = await this._medicineService.getPackageTypes(1, 10, '');

        medicine = await this
            ._medicineService
            .getMedicine(
                parseInt(route.params['id'])
            )

        if (medicine) {
            medicineDosageTypes = await this._medicineService
                .getMedicineDosageTypes(medicine.id, 1, 10, '');
        }

        if (medicine) {

        }

        return {
            medicine,
            medicineDosageTypes,
            dosageUnits,
            dosageTypes,
            packageTypes
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class MedicineListResolver implements Resolve<any> {
    limit: number = 10;
    page: number = 1;
    constructor(
        private _medicineService: MedicineService,
        private localStorageService: LocalStorageService
    ) {
        const limit = this.localStorageService.get('MEDICINE', 'LIMIT');
        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{
        medicine: Medicine[],
        pageNumber: number
    }> {
        const page = this.localStorageService.get('MEDICINE', 'PAGE');
        if (page) {
            this.page = parseInt(page);
        } else {
            this.page = 1;
        }
        const medicine = await this
            ._medicineService
            .getMedicineList(this.page, this.limit);
        return {
            pageNumber: this.page,
            medicine: medicine
        }
    }
}